/**
 * The ListController class is designed to manage the navigation of a pageable sequence of items,
 * like the video list.
 *
 * It displays all its elements using the same button classes in a vertical layout. It manages
 * proper tabbing and arrow key navigation.
 */
class SubnavController {
  /*-----------------------------------*\
   * Constructor
  \*-----------------------------------*/
  constructor($window, $timeout, $scope, $state, $rootScope) {
    this.name = 'subnav';

    this.$window = $window;
    this.$timeout = $timeout;
    this.$state = $state;
    this.$rootScope = $rootScope;

    this.$rootScope.subNavIndexItem = 0;

    this._selectedIndex = 0;
    this._labels = [];
    this._datas = [];
    this._maxItems = 7;
    this._startIndex = 0;
    this.listId = this.listId || 'NO_LIST_ID_PROVIDED';

    this.ignoreNextUp = false;

    this.labelField = 'label';
    this.statevalue = 'state';
    //console.log("this.statevalue=", this.statevalue);

    $scope.$on('focus', (event, args) => {
      //console.log("event:", event);
      //console.log("args:", args);
      if (args.id === this.listId) {
        //console.log('Focus', args.id, args.focusOnPopulate);
        this.focus(args.index, args.focusOnPopulate);
      }
    });
  }

  /*-----------------------------------*\
   * Properties
  \*-----------------------------------*/
  set items(value) {
    this._items = value;

    this._labels = [];
    this._datas = [];

    if (this._items && this._items.length) {
      this._items.forEach(item => {
        this._labels.push(item.label);
        this._datas.push(item.data);
      });
    }

    if (this.focusOnPopulateIx !== undefined) {
      //console.log('Focusing after timeout', this.focusOnPopulateIx);
      this.$timeout(_ => this.focus(this.focusOnPopulateIx));

      this.focusOnPopulateIx = undefined;
    }
  }

  //-----------------------------------
  // items
  //-----------------------------------
  get items() {
    return this._items;
  }

  //-----------------------------------
  // displayItems
  //-----------------------------------
  /**
   * Returns only the items that have been determined to be displayable based on the display
   * startIndex and the maxItems.
   *
   * @returns {*}
   */
  get displayItems() {
    return (this._items && this._items.length) ? this._items.slice(this._startIndex, this._startIndex + this._maxItems) : [];
  }

  //-----------------------------------
  // labels
  //-----------------------------------
  get labels() {
    return this._labels;
  }

  //-----------------------------------
  // datas
  //-----------------------------------
  get datas() {
    return this._datas;
  }

  //-----------------------------------
  // maxItems
  //-----------------------------------
  get maxItems() {
    return this._maxItems;
  }

  //-----------------------------------
  // startIndex
  //-----------------------------------
  set startIndex(value) {
    this._startIndex = value;
  }

  get startIndex() {
    return this._startIndex;
  }

  //-----------------------------------
  // selectedIndex
  //-----------------------------------
  get selectedIndex() {
    return this._selectedIndex;
  }

  set selectedIndex(index) {
    if (!this.items || this.items.length === 0) {
      this._selectedIndex = 0;
      return;
    }

    this._selectedIndex = index;

    if (this._selectedIndex < 0) {
      this._selectedIndex = 0;
    } else if (this._selectedIndex > this.items.length - 1) {
      this._selectedIndex = this.items.length - 1;
    }

    this.focusSelectedIndex();
  }

  /*-----------------------------------*\
   * Methods
  \*-----------------------------------*/
  focus(index, focusOnPopulate) {
    index = index ? index : 0;

    if (focusOnPopulate) {
      this.focusOnPopulateIx = index;
      return;
    }

    this.selectedIndex = this.startIndex + index;
  }

  focusSelectedIndex() {
    var elId = this.listId + '_btn' + this._selectedIndex;
    var el = document.getElementById(elId);

    //console.log('Focusing', this._selectedIndex, el, elId, this._items[this._selectedIndex].state);

    if (el) {
      el.focus();
      //el.go(this.state);
      //el.nextComponentHandler();
      this.$state.transitionTo(this._items[this._selectedIndex].state);
    } else {
      this.$timeout(this.focusSelectedIndex.bind(this));
    }
  }

  pageDown() {
    if (this.items && this.items.length > this.startIndex + this.maxItems) {
      this.startIndex += this.maxItems;

      this.$timeout(_ => {
        this.selectedIndex = this.startIndex;
      });
    }
  }

  pageUp() {
    if (this.startIndex > 0) {
      this.startIndex -= this.maxItems;

      if (this.startIndex < 0) {
        this.startIndex = 0;
      }

      this.$timeout(_ => {
        this.selectedIndex = this.startIndex + this.maxItems - 1;
      });
    }
  }

  isUp(event) {
    return event.code === 'ArrowUp' || event.keyIdentifier === 'Up';
  }

  isDown(event) {
    return event.code === 'ArrowDown' || event.keyIdentifier === 'Down';
  }

  isRight(event) {
    return event.code === 'ArrowRight' || event.keyIdentifier === 'Right';
  }

  isLeft(event) {
    return event.code === 'ArrowLeft' || event.keyIdentifier === 'Left';
  }

  /*-----------------------------------*\
   * Events
  \*-----------------------------------*/
  focusHandler(ix, event) {
    this.selectedIndex = this.startIndex + ix;
  }

  keyPressHandler($index, event) {
    if (event.charCode === 13 || event.keyCode === 13) {
      var ix = this.startIndex + $index;
      if (this.itemClickHandler) {
        this.itemClickHandler({
          index: ix,
          item: this._items[ix],
          event: event
        });
      }
    }
  }

  keyDownHandler($index, event) {
    var cancel = event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.ignoreNextUp = true;
    }

    // Down arrow or tab key
    if ((event.code === 'Tab' && !event.shiftKey) || this.isDown(event)) {
      if ($index === this.maxItems - 1 && this.items.length - 1 > this.startIndex + $index) {
        this.pageDown();
        cancel(event);
      } else if (this.selectedIndex + 1 < this.items.length) {
        this.selectedIndex++;
        cancel(event);
      } else if(this.selectedIndex + 1 === this.items.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    } else if ((event.code === 'Tab' && event.shiftKey) || this.isUp(event)) {
      console.log('Up!', $index, this.maxItems, this.startIndex);
      // Up arrow or shift tab
      if ($index % this.maxItems === 0 && this.startIndex > 0) {
        this.pageUp();
        cancel(event);
      } else if (this.selectedIndex > 0) {
        this.selectedIndex--;
        cancel(event);
      } else if(this.selectedIndex === 0) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    if (this.isRight(event)) {
      if (this.nextComponentHandler) {
        //console.log("here in nextComponentHandler");
        console.log("here in nextComponentHandler", this.selectedIndex);
        this.canNext = true;
        if(this.$rootScope.accountPastdue === true || this.$rootScope.preDeauth === true || this.$rootScope.isPPVInhibit === true){
          document.getElementById('paynow-btn').focus();
        } else {
          console.log("button not available");
        }
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    } else if (this.isLeft(event)) {
        //sETTING UP THE ROOTSCOPE TO GET BACK TO THE SAME ELEMENT IN THE SUB-MENU
        this.$rootScope.subNavIndexItem = this.selectedIndex;
        if (this.prevComponentHandler) {
        //pconsole.log("here in prevComponentHandler 2");
        console.log("here in prevComponentHandler", this.selectedIndex);
        this.canPrev = false;
        /*if(this.listId === 'tv-navigation' || this.listId === 'phone-navigation' || this.listId === 'internet-navigation'){
          document.getElementById('btn-videos').focus();
        } else if(this.listId === 'spanish-tv-navigation' || this.listId === 'spanish-phone-navigation' || this.listId === 'spanish-internet-navigation') {
          document.getElementById('btn-back-spanish').focus();
        }*/
        event.preventDefault();
        event.stopImmediatePropagation();
        }
    }
  }

  keyUpHandler($index, event) {
    if (this.ignoreNextUp) {
      this.ignoreNextUp = false;
      return;
    }

    //if (this.canNext && ((this.isDown(event) && this.selectedIndex === this.items.length - 1) || this.isRight(event))) {
    if (this.canNext && this.isRight(event)) {
      if (this.nextComponentHandler) {
        var nextIndex = this.isDown(event) ? 0 : this.selectedIndex - this.startIndex;
        this.nextComponentHandler(nextIndex, this.isDown(event));
        event.preventDefault();
        event.stopImmediatePropagation();
      }

    } else if (this.canPrev && ((this.isUp(event) && this.selectedIndex === 0) || this.isLeft(event))) {
      if (this.prevComponentHandler) {
        var nextIndex = this.isUp(event) ? this.maxItems : this.selectedIndex - this.startIndex;
        this.prevComponentHandler(nextIndex, this.isUp(event));
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    this.canNext = this.canPrev = false;
  }
}

SubnavController.$inject = ['$window', '$timeout', '$scope', '$state', '$rootScope'];

export default SubnavController;



// WEBPACK FOOTER //
// ./client/app/components/subnav/subnav.controller.js